import React from 'react';
import PropTypes from 'prop-types';
import Actions from 'components/ui/general/Actions';
import Card from 'components/ui/card/Card';
import CardText from 'components/ui/card/CardText';
import Header from 'components/ui/general/Header';
import ListButton from 'components/button/ListButton';
import ProductPropertiesCreate from './ProductPropertiesCreate';
import Title from 'components/ui/general/Title';
import compose from 'recompose/compose';
import translate from 'components/hoc/translate';
import { connect } from 'react-redux';
import Breadcrumbs from 'components/layout/Layout/Breadcrumbs';
import utils from 'helpers/utils';

class ProductPropertiesCreateContainer extends React.Component {
    render() {
        const {
            id,
            parentResource,
            product,
            resource,
            translate,
        } = this.props;

        let productName = id;

        if (!utils.isEmpty(product)) {
            productName = product.title;
        }

        const breadcrumbs = [
            {
                label: translate('resources.products.title'),
                link: '/products',
            },
            {
                label: productName,
                link: `/products/${ id }/show`,
            },
            {
                label: translate('resources.properties.title'),
            },
            {
                label: translate('actions.create'),
            },
        ];

        return (
            <div>
                <Breadcrumbs breadcrumbs={ breadcrumbs } />

                <Header>
                    <Title title={ translate('aor.page.create', { name: `${ resource }` }) } />

                    <Actions>
                        <ListButton
                            url={ `/products/${ id }/show` }
                        />
                    </Actions>
                </Header>

                <Card>
                    <CardText>
                        {
                            <ProductPropertiesCreate
                                productResource={ parentResource }
                                productId={ id }
                                resource={ resource }
                            />
                        }
                    </CardText>
                </Card>
            </div>
        );
    }
}

ProductPropertiesCreateContainer.propTypes = {
    id: PropTypes.string,
    parentResource: PropTypes.string,
    product: PropTypes.object,
    resource: PropTypes.string,
    translate: PropTypes.func.isRequired,
};

const enhance = compose(
    connect(
        (state, props) => {
            const {
                match: {
                    params: {
                        id,
                    },
                },
            } = props;

            const {
                products: {
                    data,
                },
            } = state;

            return {
                id: id,
                product: data[id],
            };
        },
        null,
    ),
    translate,
);

export default enhance(ProductPropertiesCreateContainer);



// WEBPACK FOOTER //
// ./src/pages/products/productProperties/create/ProductPropertiesCreateContainer.js